import { render, staticRenderFns } from "./dropzone-popup.vue?vue&type=template&id=c10374d2"
import script from "./dropzone-popup.vue?vue&type=script&lang=js"
export * from "./dropzone-popup.vue?vue&type=script&lang=js"
import style0 from "./dropzone-popup.vue?vue&type=style&index=0&id=c10374d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports